import { Artboard, PrintPage, ASSETS } from "../components/nk/print/PrintKit";

const PROC = [
  ["01", "Enquiry & Consultation"],
  ["02", "Design & Sketch"],
  ["03", "Design Approval"],
  ["04", "Manufacturing"],
  ["05", "Measurements & Fittings"],
  ["06", "Hand-Finished & Yours"],
];
const CREDS = ["Over 12 years' experience", "Creative, one-of-a-kind design", "Impeccable hand-finishing", "Fast, reliable turnaround", "Honest, affordable pricing"];

const Col = ({ children, style, className = "" }) => (
  <div className={`relative h-full flex-1 overflow-hidden ${className}`} style={style}>{children}</div>
);

export default function BrochurePage() {
  return (
    <PrintPage
      pageW={313}
      pageH={226}
      title="Tri-fold DL brochure — A4"
      subtitle="Two sides · 6 panels · 3 mm bleed + crop & fold marks"
      note="Print double-sided (flip on short edge) on A4, choose margins None + Background graphics. Letter-fold: fold the right panel in, then the left over it. Dashed ticks = fold lines."
    >
      {/* ===================== OUTSIDE ===================== */}
      <Artboard trimW={297} trimH={210} folds={[99, 198]} testid="brochure-outside">
        <div className="pk-grain h-full w-full flex">
          {/* Back panel */}
          <Col style={{ padding: "12mm 9mm" }}>
            <div className="h-full flex flex-col">
              <img src={ASSETS.logoDark} alt="NK Bridal" style={{ height: "16mm", width: "auto" }} className="object-contain self-start" />
              <p className="text-[9px] uppercase tracking-[0.35em] text-ink/90 mt-[4mm]">NK Bridal Australia</p>
              <div className="mt-auto space-y-[2.5mm]">
                <p className="font-serif font-semibold italic text-ink" style={{ fontSize: "15pt" }}>Let's begin.</p>
                <p className="text-ink" style={{ fontSize: "11pt" }}>0433 601 060</p>
                <p className="text-ink" style={{ fontSize: "9.5pt" }}>nkbridalaustralia@gmail.com</p>
                <p className="text-ink" style={{ fontSize: "9.5pt" }}>nkbridalaustralia.com.au</p>
                <p className="text-[8.5px] uppercase tracking-[0.25em] text-ink/90 pt-[2mm]">FB · Instagram · TikTok · @nkbridalaustralia</p>
                <p className="text-[8.5px] uppercase tracking-[0.25em] text-ink/90">Perth · Australia-wide</p>
              </div>
            </div>
          </Col>
          {/* Spine photo */}
          <Col>
            <img src={ASSETS.lace} alt="gown" className="absolute inset-0 w-full h-full object-cover object-center" />
            <div className="absolute inset-0 bg-ink/40" />
            <p className="absolute bottom-[12mm] left-[8mm] right-[8mm] font-serif font-semibold italic text-ivory" style={{ fontSize: "16pt", lineHeight: 1.1 }}>
              Bespoke bridal, made by hand.
            </p>
          </Col>
          {/* Front cover */}
          <Col style={{ background: "#FDFBF7" }}>
            <div className="h-full flex flex-col items-center text-center" style={{ padding: "14mm 9mm" }}>
              <img src={ASSETS.logoDark} alt="NK Bridal" style={{ height: "26mm", width: "auto" }} className="object-contain" />
              <p className="text-[10px] uppercase tracking-[0.45em] text-ink/90 mt-[4mm]">NK Bridal Australia</p>
              <p className="font-serif font-semibold text-ink mt-[6mm]" style={{ fontSize: "22pt", lineHeight: 1.05 }}>
                The gown you were <span className="italic">always</span> meant to wear
              </p>
              <div className="mt-auto w-full relative overflow-hidden border border-line" style={{ height: "70mm" }}>
                <img src={ASSETS.beaded} alt="gown" className="w-full h-full object-cover object-top" />
              </div>
            </div>
          </Col>
        </div>
      </Artboard>

      {/* ===================== INSIDE ===================== */}
      <Artboard trimW={297} trimH={210} folds={[99, 198]} testid="brochure-inside">
        <div className="pk-grain h-full w-full flex">
          {/* Meet Nancy */}
          <Col style={{ background: "#F2EFE9" }}>
            <div className="h-full flex flex-col" style={{ padding: "12mm 9mm" }}>
              <p className="text-[9px] uppercase tracking-[0.35em] text-champagne">Designer & Founder</p>
              <h3 className="font-serif font-semibold text-ink mt-[2mm]" style={{ fontSize: "22pt", lineHeight: 1 }}>Meet Nancy</h3>
              <div className="relative overflow-hidden border border-line mt-[5mm]" style={{ height: "62mm" }}>
                <img src={ASSETS.consult} alt="Nancy" className="w-full h-full object-cover object-center" />
              </div>
              <p className="text-ink font-semibold mt-[5mm]" style={{ fontSize: "10pt", lineHeight: 1.45 }}>
                A celebrated Brisbane seamstress, now designing in Perth. Every gown is sketched, cut and sewn by Nancy herself — built around you, never off the rack.
              </p>
              <ul className="mt-[4mm] space-y-[2mm]">
                {CREDS.map((c) => (
                  <li key={c} className="flex items-start gap-2 text-ink" style={{ fontSize: "9.5pt" }}>
                    <span className="mt-[6px] block w-[8px] h-px bg-champagne shrink-0" />{c}
                  </li>
                ))}
              </ul>
            </div>
          </Col>
          {/* The Process */}
          <Col style={{ background: "#F2EFE9" }}>
            <div className="h-full flex flex-col" style={{ padding: "12mm 9mm" }}>
              <p className="text-[9px] uppercase tracking-[0.35em] text-champagne">The Experience</p>
              <h3 className="font-serif font-semibold text-ink mt-[2mm]" style={{ fontSize: "22pt", lineHeight: 1 }}>From sketch to “I do”</h3>
              <div className="mt-[7mm] flex-1 flex flex-col justify-start gap-[5mm]">
                {PROC.map(([n, t]) => (
                  <div key={n} className="flex items-baseline gap-[5mm] border-b border-line pb-[3mm]">
                    <span className="font-serif font-semibold text-champagne" style={{ fontSize: "17pt" }}>{n}</span>
                    <span className="font-semibold text-ink" style={{ fontSize: "11pt" }}>{t}</span>
                  </div>
                ))}
              </div>
            </div>
          </Col>
          {/* My Brides */}
          <Col>
            <div className="h-full flex flex-col" style={{ padding: "12mm 9mm" }}>
              <h3 className="font-serif font-semibold italic text-ink" style={{ fontSize: "24pt", lineHeight: 1 }}>My brides,</h3>
              <p className="text-ink font-semibold mt-[5mm]" style={{ fontSize: "10pt", lineHeight: 1.5 }}>
                Every gown is unique in style and fabric, so I warmly recommend booking a <b>free appointment</b> for a personal experience, looked after by me. Or visit the website for the price list and to book online.
              </p>
              <div className="relative overflow-hidden border border-line mt-[5mm]" style={{ height: "58mm" }}>
                <img src={ASSETS.couple} alt="bride and groom" className="w-full h-full object-cover object-top" />
              </div>
              <div className="mt-auto pt-[4mm] border-t border-line">
                <p className="font-serif font-semibold italic text-ink" style={{ fontSize: "13pt" }}>Kind regards, Nancy &amp; team</p>
                <p className="text-ink/95 mt-[2mm]" style={{ fontSize: "10pt" }}>0433 601 060 · nkbridalaustralia.com.au</p>
              </div>
            </div>
          </Col>
        </div>
      </Artboard>
    </PrintPage>
  );
}
